import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, AlertCircle } from 'lucide-react';
import { workHeadline, firstLine, formatLabor, followUpState, historyTypeLabel } from '../../lib/historyList';
import { formatDayLabel, localBucketDay } from '../../lib/historyMeta';
import { HistoryRecordDetails } from './HistoryRecordDetails';

export const HistoryRecordRow = ({ event: e, expanded, onToggle, hideEquipment = false, ...actions }) => {
  const status = followUpState(e);
  const day = localBucketDay(e);
  const date = day ? formatDayLabel(day).replace(/^[^,]+, /, '') : 'Undated';
  return <li className={`history-record ${expanded ? 'is-expanded' : ''} ${status === 'open' ? 'needs-follow-up' : ''}`}
    id={`history-record-${e.id}`} data-testid={`history-row-${e.id}`}>
    <div className="history-row-grid">
      <time className="history-date" dateTime={day || undefined} data-testid={`history-date-${e.id}`}>{date}</time>
      {!hideEquipment && <div className="history-equipment-cell">
        {e.machinery_id ? <Link to={`/machinery/${e.machinery_id}`} data-testid={`history-equipment-${e.id}`}>{e.equipment_name}</Link>
          : <span className="history-equipment-name" data-testid={`history-equipment-${e.id}`}>{e.equipment_name}</span>}
        <span className="history-location" data-testid={`history-location-${e.id}`}>{e.location_name || 'Unassigned location'}</span>
      </div>}
      <button type="button" className="history-work" data-testid={`history-summary-${e.id}`}
        aria-expanded={expanded} aria-controls={`history-details-${e.id}`} onClick={onToggle}>
        <span className="history-work-title" data-testid={`history-title-${e.id}`}>{workHeadline(e)}</span>
        {firstLine(e.resolution) && <span className="history-outcome" data-testid={`history-outcome-${e.id}`}>
          {e.event_type === 'completed_work_order' ? 'Completion notes: ' : 'Resolution: '}{firstLine(e.resolution)}
        </span>}
        <span className="history-type" data-testid={`history-type-${e.id}`}>{historyTypeLabel(e)}{e.wo_number ? ` · #${e.wo_number}` : ''}</span>
      </button>
      <span className="history-labor" data-testid={`history-hours-${e.id}`}><span className="history-mobile-label">Labor </span>{formatLabor(e.hours_spent)}<span className="history-mobile-label"> h</span></span>
      <span className={`history-follow-up ${status === 'open' ? 'history-attention' : ''}`} data-testid={`history-follow-up-status-${e.id}`}
        title={status === 'none' ? 'No follow-up recorded' : 'Current follow-up status'}>
        {status === 'open' && <AlertCircle size={13} aria-hidden="true" />}
        {status === 'open' ? 'Required' : status === 'resolved' ? 'Closed' : status === 'unknown' ? 'Check details' : '—'}
      </span>
      <button type="button" className="history-expand" data-testid={`history-expand-${e.id}`} onClick={onToggle}
        aria-label={`${expanded ? 'Collapse' : 'Expand'} ${e.equipment_name}: ${workHeadline(e)}`}
        aria-expanded={expanded} aria-controls={`history-details-${e.id}`} title={expanded ? 'Collapse details' : 'Expand details'}>
        <ChevronDown size={18} aria-hidden="true" />
      </button>
    </div>
    {expanded && <HistoryRecordDetails event={e} {...actions} />}
  </li>;
};